import util from '../util'

let controller = 'OperadorRetaguardaSubparceiro'

export default Object.assign({}, util.GetCrud(controller, null), {
    Desativar: function (codigo) {
        return util.Axios.Post(controller + `/${codigo}/desativar`,{})
      },
    Historico: function (dto, options){
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + '/Historico', dto)
      }
})
